import _ from 'lodash-es';
import queryString from 'query-string';

import { NEXT_PUBLIC_RALLIT_HOST } from '../../appConfig';
import { AUTH_URL, INFLEARN_URL } from '../constants/urls';
import { getReferUrlOrFallback, isOurUrl } from '../utils/url';
import { useCurrentUrl } from './useCurrentUrl';

export const REFER_URL_QUERY_KEY = 'referUrl';
const REFERER_QUERY_KEY = 'referrer';

export function useReferUrlNavigation() {
  const { currentUrlWithoutQueryString } = useCurrentUrl();

  const getReferUrl = (isFirst = false) => {
    if (typeof document === 'undefined' || typeof location === 'undefined') {
      return INFLEARN_URL.MAIN();
    }

    const searchParams = queryString.parse(location.search);

    const referUrl = searchParams[REFER_URL_QUERY_KEY]?.toString() || '';

    if (isFirst) {
      // TODO: referrer 역할 확인 필요. referUrl와 동일한 역할을 할 시 referUrl로 통일할 예정
      // 현재 파악한 내용: email 인증 시 email template 내 referUrl이 referrer로 변환되어 전달되고 있음
      const referer = searchParams[REFERER_QUERY_KEY]?.toString() || '';
      const finalReferUrl = referUrl || referer;

      return queryString.stringifyUrl({
        url: getReferUrlOrFallback(finalReferUrl, INFLEARN_URL.COURSES()),
        query: {
          to: 'first_hello',
          referUrl: referer,
        },
      });
    }

    const fallbackUrl =
      currentUrlWithoutQueryString === AUTH_URL.FIND_PASSWORD() && !_.isEmpty(document.referrer)
        ? document.referrer
        : INFLEARN_URL.MAIN();

    return isOurUrl(referUrl) ? referUrl : fallbackUrl;
  };

  const getMainUrl = () =>
    getReferUrl().includes('rallit') ? NEXT_PUBLIC_RALLIT_HOST : INFLEARN_URL.MAIN();

  const navigateReferUrl = () => {
    location.href = getReferUrl();
  };

  const navigateMainUrl = () => {
    location.href = getMainUrl() ?? '';
  };

  return { navigateReferUrl, navigateMainUrl, getReferUrl, getMainUrl };
}
